import { useState } from 'react';
import { Checkbox, Dialog, Tile, } from '@components';
import { FREIGHT_MODE } from '@types';
import { getFreightModeLabel } from '@utils';
import styles from './RequestQuoteModeModal.module.scss';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import TrainOutlinedIcon from '@mui/icons-material/TrainOutlined';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';

const FREIGHT_MODE_OPTIONS = [
	{ mode: FREIGHT_MODE.ROAD, icon: <LocalShippingOutlinedIcon /> },
	{ mode: FREIGHT_MODE.RAIL, icon: <TrainOutlinedIcon /> },
	{ mode: FREIGHT_MODE.COASTAL, icon: <DirectionsBoatOutlinedIcon /> },
];

type Props = {
	open: boolean;
	onClose: () => void;
	onConfirm: (selectedModes: FREIGHT_MODE[]) => void;
	alreadyPricedModes?: FREIGHT_MODE[];
	isLoading?: boolean;
}

export const RequestQuoteModeModal = ({ open, onClose, onConfirm, alreadyPricedModes = [], isLoading = false }: Props) => {
	const [selectedModes, setSelectedModes] = useState<FREIGHT_MODE[]>([]);

	const toggleMode = (mode: FREIGHT_MODE) => {
		setSelectedModes((prev) =>
			prev.includes(mode) ? prev.filter((m) => m !== mode) : [...prev, mode]
		);
	};

	const handleConfirm = () => {
		onConfirm(selectedModes);
		setSelectedModes([]);
	};

	const handleClose = () => {
		setSelectedModes([]);
		onClose();
	};

	return (
		<Dialog
			open={open}
			onClose={(val) => { if (!val) handleClose(); }}
			title='Request a Quote'
			text='Select the freight mode(s) you need a quote for'
			actionButtonFn={handleConfirm}
			actionButtonText='Confirm'
			cancelButtonText='Cancel'
			actionButtonDisabled={selectedModes.length === 0}
			actionButtonLoading={isLoading}
			size='small'
			slot={
				<div className={styles.optionsList}>
					{FREIGHT_MODE_OPTIONS.map(({ mode, icon }) => {
						const isSelected = selectedModes.includes(mode);
						const isDisabled = alreadyPricedModes.includes(mode);
						return (
							<Tile
								key={mode}
								selected={isSelected}
								onClick={() => !isDisabled && toggleMode(mode)}
							>
								<div className={`${styles.optionContent} ${isDisabled ? styles.disabled : ''}`}>
									<span className={styles.optionLeft}>
										<span className={`${styles.icon} ${isSelected ? styles.iconSelected : ''}`}>{icon}</span>
										<span>{getFreightModeLabel(mode)}</span>
									</span>
									<div onClick={(e) => e.stopPropagation()}>
										<Checkbox
											name={`freight-mode-${mode}`}
											label=''
											value={mode}
											checked={isSelected}
											onChange={() => !isDisabled && toggleMode(mode)}
											disabled={isDisabled}
										/>
									</div>
								</div>
							</Tile>
						);
					})}
				</div>
			}
		/>
	);
};
